<template>
  <v-dialog
    v-model="planDialog"
    width="632px">
    <div class="dialog-container">
      <div class="plan-header">
        <div
          v-if="!isSMEProduct"
          class="logo">
          <img
            :src="companyLogo"
            alt="logo" />
        </div>
        <div class="info">
          <h2>{{ plan }}</h2>
          <!-- <h2 v-else>{{ getOptionName('classOptions', planInfo.class_id) }} + {{ getOptionName('coverTypeOptions', planInfo.trm_of_cvr) }} Plan</h2> -->
          <div>
            <v-button
              v-for="(item, index) in policyDetail.items"
              :key="index"
              type="info"
              @click="openReferenceQuote(item)">{{ item.file_name }}</v-button>
            <!--            <v-button-->
            <!--              v-if="haveReferenceQuote"-->
            <!--              type="info"-->
            <!--              @click="openReferenceQuote">Quotation</v-button>-->
            <!-- <v-button
              type="info"
              @click="handlerToPlan">More Plan Info</v-button> -->
            <!-- <v-button type="info">Policy Brochure</v-button>
            <v-button type="info">Policy Wordings</v-button>
           -->
          </div>
          <div class="money-container">
            <span class="amount">{{ payable | formatMoney(2, false) }}</span>
            <span class="unit">HK$ per year</span>
          </div>
        </div>
      </div>
      <all-company-quote-plan-info
        :is-sme-product="isSMEProduct"
        :planInfo="planInfo" />
      <!-- <housemaid-company-quote-plan-info
        v-if="productId == 12"
        :planInfo="planInfo" />
      <company-quote-plan-info
        v-else-if="[13, 16].includes(productId)"
        :planInfo="planInfo" />
      <travel-company-quote-plan-info
        v-else-if="productId == 14"
        :planInfo="planInfo" />
      <decoration-company-quote-plan-info
        v-else-if="productId == 15"
        :planInfo="planInfo" />
      <homefire-company-quote-plan-info
        v-else-if="productId == 17"
        :planInfo="planInfo" />
      <motor-company-quote-plan-info
        v-else
        :planInfo="planInfo" /> -->


      <v-button @click="changeDialog">Close</v-button>
    </div>
  </v-dialog>
</template>
<script>
import {mapState} from 'vuex'
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import AllCompanyQuotePlanInfo from '../modules/components/company-quote-plan-info'
import {downloadFileName} from '@/utils/download'

export default {
  name: 'PlanDialog',
  components: {
    // MotorCompanyQuotePlanInfo,
    // HousemaidCompanyQuotePlanInfo,
    // CompanyQuotePlanInfo,
    // TravelCompanyQuotePlanInfo,
    // DecorationCompanyQuotePlanInfo,
    // HomefireCompanyQuotePlanInfo,
    AllCompanyQuotePlanInfo
  },
  mixins: [MixinOptions, MixinFormat],
  props: {
    planInfo: {
      type: Object,
      default: () => ({
        excess: {},
        coverage: {},
        plan_info: {
          company_logo: '',
          plan: '',
          payable: ''
        },
        policy_detail: {
          items: []
        }
      })
    },
    haveReferenceQuote: {
      type: Boolean,
      default: false
    },
    isRenew: {
      type: Boolean,
      default: false
    },
    detail_b:{
      type: Array,
      default: () => []
    },
    index:{
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      planDialog: false
    }
  },
  computed: {
    ...mapState('common', ['productId']),
    classId() {
      return this.planInfo.class_id || 14
    },
    isSMEProduct(){
      let {product_id} = this.$route.query||{}
      return product_id>80
    },
    quoteId() {
      let {plan_info={}} = this.planInfo
      let {quo_id} = plan_info||{}
      return quo_id
    },
    companyLogo() {
      if(!this.planInfo || !this.planInfo.plan_info || !this.planInfo.plan_info.company_logo) {
        return ''
      }
      return this.planInfo.plan_info.company_logo
    },
    plan() {
      if(this.isSMEProduct){
        let {package_info={}} = this.planInfo
        return package_info.package_name
      }
      if(!this.planInfo || !this.planInfo.plan_info || !this.planInfo.plan_info.plan) {
        return ''
      }
      return this.planInfo.plan_info.plan
    },
    payable() {
      if(this.isSMEProduct){
        let {amount} = this.planInfo
        return Number(amount)
      }
      if(!this.planInfo || !this.planInfo.plan_info || !this.planInfo.plan_info.payable) {
        return ''
      }
      return this.planInfo.plan_info.payable
    },
    policyDetail() {
      if(this.planInfo && this.planInfo.policy_detail) {
        return this.planInfo.policy_detail
      }
      return {
        items: []
      }
    }
  },
  methods: {
    openFile(url) {
      if (url) {
        window.open(url, '_blank')
      }
    },
    openReferenceQuote(item) {
      let quo_id = null
      if(this.detail_b.length && this.detail_b[this.index] && this.detail_b[this.index].plan_info){
        quo_id = this.detail_b[this.index].plan_info.quo_id || null
      }
      let {file_type,file_url, file_name} = item||{}

      // file_type = reference的时候需要弹出下载框下载
      if(file_type=='reference' && (!this.isRenew || !quo_id)){
        // 请求对应的接口
        this.$emit('get-reference-quote',file_url)
      }else if(file_type=='reference'){
        // 将文件地址转换为文件流再下载
        downloadFileName(file_url, `${file_name}.pdf`)
      }else{
        // 其他的直接打开文件
        this.openFile(file_url)
      }
    },
    changeDialog() {
      this.planDialog = !this.planDialog
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-container {
  padding: 15px;
  .plan-header {
    display: flex;
    .logo {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 15px;
      width: 150px;
      height: 80px;
      img {
        max-width: 100%;
        max-height: 100%;
      }
    }
    .info {
      .money-container {
        margin-top: 5px;
        .amount {
          padding-right: 5px;
          font-size: 24px;
          font-weight: bold;
          color: #409eff;
        }
        .unit {
          color: #616266;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
